import * as yup from "yup";
import { getRole, getstatus } from "./EmployeeServices";
import { emailRegex, floatingRegex, nameRegex, phoneRegex, wordToWordSpaceRegex } from "../../components/common/Helpers/Validations";
export const formFields: any = [
    {
        label: "First Name",
        type: 'text',
        name: 'f_name',
        placeholder: 'Enter First Name'
    },
    {
        label: "Last Name",
        type: 'text',
        name: 'l_name',
        placeholder: 'Enter Last Name'
    },
    {
        label: "Email",
        type: 'text',
        name: 'email',
        placeholder: 'Enter Email'
    },
    {
        label: "Mobile Number",
        type: 'text',
        name: 'mobile_number',
        placeholder: 'Enter Mobile Number'
    },
    {
        label: "City",
        type: 'text',
        name: 'city',
        placeholder: 'Enter City'
    },
    {
        label: "State",
        type: 'text',
        name: 'state',
        placeholder: 'Enter State'
    },
    {
        label: "Experience",
        type: 'number',
        name: 'experience',
        placeholder: 'Enter Experience'
    },
    {
        label: "Previous Company",
        type: 'text',
        name: 'previous_company',
        placeholder: 'Enter Previous Company'
    },
    {
        label: "Job Role",
        type: 'text',
        name: 'job_role',
        placeholder: 'Enter Job Role'
    },
    {
        label: "Resume Upload",
        type: 'file',
        name: 'resume_upload',
        placeholder: 'Enter Resume Upload'
    },
    {
        label: "Skills",
        type: 'text',
        name: 'skills',
        placeholder: 'Enter Skills'
    },
]

export const validationSchema = yup.object({
    f_name: yup.string().ensure().required("First Name is required!").matches(nameRegex,{message:"Please enter only Alpha Letters!"}).matches(wordToWordSpaceRegex,{message:"Please do not include leading spaces!"}).min(3, 'To short!'),
    l_name: yup.string().ensure().required(" Last Name is required!").matches(nameRegex,{message:"Please enter only Alpha Letters!"}).matches(wordToWordSpaceRegex,{message:"Please do not include leading spaces!"}).min(3, 'To short!'),
    email: yup.string().ensure().required("Email is required!").matches(emailRegex,{message:'Enter Valid Email!',}).min(3, 'To short!'),
    mobile_number: yup.string().ensure().required(" Mobile Number is required!").min(10, 'Invalid Mobile Number').max(10, 'Invalid Mobile Number').matches(phoneRegex,{message:'Enter Valid Phone Number',}),
    city: yup.string().ensure().required("City is required!").min(3, 'To short!'),
    state: yup.string().ensure().required("State is required!").min(3, 'To short!'),
    experience: yup.string().ensure().required("Experience is required!").matches(floatingRegex,{message:'Please enter only Numbers!',}),
    previous_company: yup.string().ensure().required("Previous Company is required!").min(3, 'To short!'),
    job_role: yup.string().ensure().required("Job Role is required!").min(3, 'To short!'),
    resume_upload: yup.string().ensure().required("Resume Upload is required!").min(3, 'To short!'),
    skills: yup.string().ensure().required("Skills is required!").min(3, 'To short!'),
});